
export const environment = {
    production: !window.location.hostname.includes("test"),
    baseServiceURL: window.location.hostname.includes("insighttest") ? "https://insighttest.rccbi.com/publicapi"
        : (window.location.hostname.includes("insight") ? "https://insight.rccbi.com/publicapi"
            : (window.location.hostname.includes("webhubtest") ? "https://webhubtest.rccbi.com/publicapi"
                : "https://webhub.rccbi.com/publicapi")),
    iconUrl: "./v2/assets/img"
};
